<div id="mainLoader" class="mainLoader" *ngIf="showLoader">
  <div class="loader-parent">
    <div class="line" [ngClass]="{ k12: productTitle === 'K12 Insight' }"></div>
    <div class="line" [ngClass]="{ k12: productTitle === 'K12 Insight' }"></div>
    <div class="line" [ngClass]="{ k12: productTitle === 'K12 Insight' }"></div>
    <div class="line k12" *ngIf="productTitle === 'K12 Insight'"></div>
  </div>
</div>
<form
  id="form1"
  *ngIf="!showLoader && socialAuth && socialAuth.SocialAuthHead"
  [ngClass]="{ 'mobile-wrapper': isMobile }"
>
  <div class="msg-bg-overlay"></div>
  <div id="fb-root"></div>
  <div class="SurveyMsgWrapper">
    <div class="message-wrapper">
      <div class="">
        <ng-container *ngIf="isMobile; else webHeader">
          <div>
            <div class="message-heading-text-fb">
              <div>
                <asp:Label
                  ID="lblSocialAuthHead1"
                  [innerHTML]="socialAuth?.SocialAuthHead1 | headerFooterHtml"
                />
              </div>
            </div>
          </div>
          <div class="mobile-message-icon-fb"></div>
        </ng-container>
        <ng-template #webHeader>
          <div class="message-header-wrapper">
            <div class="message-icon browser-message"></div>
            <div class="message-heading-text">
              <asp:Label
                ID="lblSocialAuthHead"
                [innerHTML]="socialAuth?.SocialAuthHead | headerFooterHtml"
              />
            </div>
          </div>
        </ng-template>
      </div>
      <div class="message-info-wrapper image-width sogo">
        <div id="fb-message-text" class="message-text">
          <div class="subhead soc-padding">
            <span
              id="txtSocialAuthMsg"
              [innerHTML]="socialAuth?.SocialAuthMsg | headerFooterHtml"
            ></span>
          </div>
          <div id="buttonwrapper">
            <div
              *ngIf="socialAuth?.isOnlyFacebook"
              id="dvSingle"
              runat="server"
              style="text-align: center"
            >
              <a class="facebookbtn btn-spacing" (click)="FaceBookSignInParticipation()">
                <span class="social-icon"></span>
                <span
                  id="txtSocialAuthBtnText"
                  [innerHTML]="socialAuth?.SocialAuthBtnText | headerFooterHtml"
                ></span>
              </a>
            </div>
            <div
              *ngIf="socialAuth?.isOnlyLinkedIn"
              id="dvSingle"
              runat="server"
              style="text-align: center"
            >
              <a class="linkinbtn btn-spacing" (click)="AuthorizeLinkedIn()">
                <span class="social-icon"></span>
                <span
                  id="txtSocialAuthBtnText"
                  [innerHTML]="socialAuth?.SocialAuthBtnText3 | headerFooterHtml"
                ></span>
              </a>
            </div>
            <div
              *ngIf="socialAuth?.isFacebookLinkedIn"
              id="dvDouble"
              runat="server"
              style="text-align: center"
            >
              <span id="spanfb" runat="server">
                <a class="facebookbtn btn-spacing 1" (click)="FaceBookSignInParticipation()">
                  <span class="social-icon"></span>
                  <span
                    id="txtSocialAuthBtnText2"
                    [innerHTML]="socialAuth?.SocialAuthBtnText2 | headerFooterHtml"
                  ></span>
                </a>
              </span>
              <span id="spanlnk" *ngIf="socialAuth?.SocialAuthBtnText3">
                <a
                  class="linkinbtn btn-spacing"
                  style="text-decoration: none"
                  href="javascript:void(0);"
                  (click)="AuthorizeLinkedIn()"
                >
                  <span class="social-icon"></span>
                  <span
                    id="txtSocialAuthBtnText3"
                    [innerHTML]="socialAuth?.SocialAuthBtnText3 | headerFooterHtml"
                  ></span>
                </a>
              </span>
            </div>
          </div>
          <div class="newNoteContent NoteComponent">
            <span
              id="txtSocialAuthMsg1"
              [innerHTML]="socialAuth?.SocialAuthMsg1 | headerFooterHtml"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="isMobile; else WebErrFooter">
    <div class="footer-div survey-messages-footer">
      <div *ngIf="!socialAuth?.isPoweredByClient" class="btmNote onlyMessage" style="width: 100%">
        <a href="{{ socialAuth?.strProductHostUrl }}" class="footrAnchor" target="_blank"></a>
        <span
          >Powered by
          <img
            alt="Product Image"
            *ngIf="this.productTitle !== 'K12 Insight'"
            src="../survey/assets/ProductImages/small_svglogo.svg" />
          <img
            alt="Product Image"
            *ngIf="this.productTitle === 'K12 Insight'"
            src="../survey/assets/ProductImages/k12logo.svg"
        /></span>
        <span [innerHTML]="socialAuth?.strPrivacyPolicy | headerFooterHtml"></span>
      </div>
    </div>
  </ng-container>
  <ng-template #WebErrFooter>
    <div class="footer-div survey-messages-footer">
      <div *ngIf="!socialAuth?.isPoweredByClient" class="btmNote onlyMessage" style="width: 100%">
        <a href="{{ socialAuth?.strProductHostUrl }}" class="footrAnchor" target="_blank"></a>
        <span
          >Powered by
          <img
            alt="Product Image"
            *ngIf="this.productTitle !== 'K12 Insight'"
            src="../survey/assets/ProductImages/small_svglogo.svg" />
          <img
            alt="Product Image"
            *ngIf="this.productTitle === 'K12 Insight'"
            src="../survey/assets/ProductImages/k12logo.svg"
        /></span>
        <span [innerHTML]="socialAuth?.strPrivacyPolicy | headerFooterHtml"></span>
      </div>
    </div>
  </ng-template>
</form>
